import { useContext } from "react";
/// my imports:
import Hint from "@/app/components/Hint";
import { AnyGameObj } from "@/app/lib/game-state/game-types";
import { Contexts } from "@/app/components/Context";
import UI from "@/app/lib/ui/ui";


export default function OriginalWordHint() {

    const activeGame: AnyGameObj | null = useContext(Contexts.ActiveGame);
    const ui: UI | null = useContext(Contexts.UI);

    if (!activeGame || !ui) {
        console.warn('bad context in OriginalWordHint');
        return null;
    }
    
    // only render on completion
    // only render if ui is set to a hint
    if (!activeGame.state.completed || !ui.originalWordHint) {
        return null;
    }

    function dismissHint() {
        ui?.hideOriginalWordHint();
    }

    // get the position for hint rendering
    const element = ui.letterRefs.current
        [ui.originalWordHint.wordIndex][ui.originalWordHint.letterPosition]
    
    if (!element)
        return null;

    const rect = element.getBoundingClientRect();
    const position = {
        x: rect.left + window.scrollX,
        y: rect.top + window.scrollY
    };

    const hintText: string = `Word used to build puzzle:
        - ${activeGame.state.words[ui.originalWordHint.wordIndex].puzzleWord}`
    const linkText: string = 'Dismiss'

    return (
        <Hint 
            position={position}
            text={hintText}
        />
    )
}